module.exports = __webpack_public_path__ + "media/images/game_icon/en/VG1003-6408aaa25658f6973673e8b6cf664657.png";